module.exports = __webpack_public_path__ + "src/images/products/allAmerican/77_Olive Slim Twill Suit Jacket.png";